import React from 'react';
import { Box } from '@material-ui/core';

import SearchPedido from 'components/util/searchPedido/.mixins';
import { SearchOptions } from './SearchOptions';
import { OrderStatus } from './OrderStatus';
import { useSearchField } from 'pages/orderHistory/hooks/useFilters/useSearchField';
import { useStyles } from './styles';

export const Filters = () => {
  const styles = useStyles();

  const { searchField, isSearchFieldActive, handleChangeSearchField, handleClickSearchField, clearSearchField } =
    useSearchField();

  return (
    <Box className={styles.container}>
      <SearchPedido
        label="Pesquisar pedidos"
        searchField={searchField}
        searchStatus={isSearchFieldActive}
        handleChangeSearchFieldPedido={handleChangeSearchField}
        handleClickSearchField={handleClickSearchField}
      />

      <SearchOptions
        searchField={searchField}
        handleChangeSearchField={handleChangeSearchField}
        clearSearchField={clearSearchField}
      />

      <OrderStatus />
    </Box>
  );
};
